import { Row, Col, Table, Input, Spin, message } from "antd";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import Back from "../../../../assets/images/backIcon.svg";
import CustomerSearch from "../../../../assets/images/c-serach.svg";
import Retrieve from "../../../../assets/images/retrieve.png";
import Cancel from "../../../../assets/images/cancel-new.svg";
import useCartStore from "../../../../stores/useCartStore";

const SMParkedBillsView = ({
  colorVariable,
  posConfig,
  themeJSON,
  isParkedBill,
  setIsparkedBill,
  setIsInputFocused,
  setParkedBillSearchInput,
  setLayoutName,
  parkedBillSearchInput,
  searchParkedBill,
  onChangeParkedBill,
  keyboard,
  setInputName,
  setOpen,
  filterdParkedList,
  setFilterdParkedList,
  parkedList,
  columns,
  selectedKeys,
  expandedRowKeys,
  handleExpandPerkedData,
  tillData,
  pricePrecision,
  setTableValue,
  retrieveParkedData,
  upsertPOSLog,
  cart,
  setCart,
  setParkedBill,
  discardMessage,
  parkedBillRef,
  setShowPaymentMethods,
  setOrderHistoryDetails,
  setSelectedProductInCart,
  setProductStock,
  setTempCart,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
}) => {
  // Fallback: old-style parked bills view (saveParkedBills !== "Y")
  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
        <Col
          span={6}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8vw",
          }}
        >
          <img
            src={Back}
            id="sm-parked-bill-back"
            onClick={() => {
              setIsparkedBill(false);
              setIsInputFocused(false);
              setParkedBillSearchInput("");
              setLayoutName("default");
              setFilterdParkedList(parkedList);
            }}
            style={{
              height: "2.2vw",
              cursor: "pointer",
            }}
          />
          <span
            style={{
              fontSize: "1.8em",
              fontWeight: 500,
              color: "#0F0718",
              lineHeight: 1,
            }}
          >
            Parked Bills
          </span>
        </Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder={`Search for customers`}
            ref={parkedBillRef}
            prefix={<img src={CustomerSearch} style={{ width: "1.5em", margin: "0.75em" }} alt="" />}
            allowClear={false}
            style={{ width: "70%", borderRadius: "5px", border: "none" }}
            onPressEnter={() => {
              searchParkedBill(parkedBillSearchInput);
            }}
            onChange={(e) => {
              onChangeParkedBill(e.target.value);
              keyboard?.current?.setInput(e.target.value);
            }}
            id="sm-parked-bill-customer"
            onFocus={() => {
              setTimeout(() => {
                setInputName("parkedBill");
                setOpen(true);
                keyboard?.current?.setInput(parkedBillSearchInput);
              }, 300);
            }}
            onBlur={() => {
              setIsInputFocused(false);
            }}
            value={parkedBillSearchInput}
            className="parkedCustomer-sm"
            width={700}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ padding: "0 1em" }}>
        <Table
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            fontSize: "1vw",
            borderRadius: "10px",
            padding: "0 1em",
            height: "83vh",
            background: themeJSON.productTableBGColor || "#fff",
          }}
          pagination={false}
          columns={columns}
          dataSource={filterdParkedList}
          rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
          className="sm-cart-table"
          expandable={{
            expandedRowKeys,
            onExpand: handleExpandPerkedData,
            expandedRowRender: (record) => (
              <div
                style={{
                  padding: "1% 4% 1% 4%",
                  backgroundColor: "#f3f4f9",
                }}
              >
                <Row>
                  <Col span={21}>
                    <Row>
                      <Col span={12} className="td-nested-title-sm">
                        Description
                      </Col>
                      <Col span={3} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                        Qty
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                        Unit Price
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "right" }}>
                        Net Total
                      </Col>
                    </Row>
                    <Row style={{ paddingBottom: "0.5vw", fontSize: "1vw" }}>
                      {record.parkedCart.items.map((e) => {
                        return (
                          <>
                            <Col span={12} className="td-nested-title-sm" style={{ fontSize: "1.2em" }}>
                              {e.name}
                            </Col>
                            <Col
                              span={3}
                              style={{
                                textAlign: "center",
                                fontWeight: "400",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.weight}
                            </Col>
                            <Col span={1} style={{ textAlign: "center" }} />
                            <Col
                              span={3}
                              style={{
                                textAlign: "right",
                                fontWeight: "400",
                                paddingRight: "1vw",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.realPrice}
                            </Col>
                            <Col span={1} style={{ textAlign: "right" }} />
                            <Col
                              span={3}
                              style={{
                                textAlign: "right",
                                marginLeft: "6vw",
                                fontWeight: "400",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.nettotal?.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                    <p
                      style={{
                        width: "96%",
                        marginLeft: "0%",
                        borderTop: "1.3px solid rgba(52, 40, 44, 0.55)",
                        marginBottom: "0px",
                      }}
                    />
                    <Row style={{ paddingTop: "5px" }}>
                      <Col span={3} offset={17} className="td-subtotal">
                        <span className="td-subTotalText">Subtotal</span>
                        <span className="td-subTotalText">Total tax</span>
                      </Col>
                      <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                        <span className="td-subTotalText">{(record.parkedCart.total - record.parkedCart.tax).toFixed(pricePrecision)}</span>
                        <span className="td-subTotalText">{record.parkedCart.tax.toFixed(pricePrecision)}</span>
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "1%" }}>
                      <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                        <span className="td-total">SALE TOTAL</span>
                      </Col>
                      <Col
                        span={3}
                        className="td-subtotal"
                        style={{
                          borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                          textAlign: "right",
                          paddingTop: "4px",
                        }}
                      >
                        <span className="td-total">{record.parkedCart.total}</span>
                      </Col>
                    </Row>
                  </Col>
<Col
  span={3}
  className="td-bottons"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "0.5vw",
    justifyContent: "center",
  }}
>
                    <p
                      style={{
                        cursor: "pointer",
                        padding: "5.5% 12%",
                        borderRadius: "3px",
                        border: "1px solid #fff",
                        background: "#fff",
                        fontSize: "1em",
    margin: 0,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        setTableValue("POS");
                        retrieveParkedData(record);
                        upsertPOSLog(cart, "OPK", "Retrieved");
                      }}
                      id="sm-parked-bill-retrieve"
                    >
                      <img
                        src={Retrieve}
                        style={{
                          height: "1vw",
                          paddingRight: "0.4vw",
                          cursor: "pointer",
                        }}
                      />
                      Retrieve sale
                    </p>
                    <p
                      style={{
                        cursor: "pointer",
                        padding: "5.5% 13%",
                        borderRadius: "3px",
                        border: "1px solid #fff",
                        background: "#fff",
                        fontSize: "1em",
    margin: 0,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        setParkedBill(record);
                        discardMessage("Discard Sale", "Are you sure you want to discard the sale!", record);
                      }}
                      id="sm-parked-bill-discard"
                    >
                      <img src={Cancel} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                      Discard sale
                    </p>
                  </Col>
                </Row>
              </div>
            ),
            expandIcon: ({ expanded, onExpand, record }) => (
              <span id="sm-parked-bill-expand" onClick={(e) => onExpand(record, e)}>
                {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
              </span>
            ),
          }}
          onRow={(record) => ({
            onClick: () => handleExpandPerkedData(record),
          })}
          onExpand={handleExpandPerkedData}
        />
      </Row>
    </div>
  );
};

export default SMParkedBillsView;
